import * as React from 'react';
import { Classes, Colors } from '@pinpointhq/thumbtack';

interface ITabsExpanderProps {
  muted?: boolean;
}

export default function TabsExpander(props: ITabsExpanderProps) {
  const { muted = false } = props;

  return (
    <div className={Classes.FLEX_EXPANDER} style={{ backgroundColor: muted ? Colors.IVORY_05 : Colors.SAGE_50 }} />
  );
}
